var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCalculator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.62283 2.75073C4.32504 2.75073 4.0835 2.99228 4.0835 3.29007V12.7107C4.0835 13.0085 4.32504 13.2501 4.62283 13.2501H11.3775C11.675 13.2501 11.9168 13.0088 11.9168 12.7101V3.29007C11.9168 2.99253 11.6755 2.75073 11.3768 2.75073H4.62283ZM11.3775 14.7501H4.62283C3.49662 14.7501 2.5835 13.8369 2.5835 12.7107V3.29007C2.5835 2.16385 3.49662 1.25073 4.62283 1.25073H11.3768C12.5035 1.25073 13.4168 2.1636 13.4168 3.29007V12.7101C13.4168 13.8367 12.504 14.7501 11.3775 14.7501Z",
    className: "icon-fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5835 5.3335C2.5835 4.91928 2.91928 4.5835 3.3335 4.5835H12.6668C13.081 4.5835 13.4168 4.91928 13.4168 5.3335C13.4168 5.74771 13.081 6.0835 12.6668 6.0835H3.3335C2.91928 6.0835 2.5835 5.74771 2.5835 5.3335Z",
    className: "icon-fill"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.38347 10.9971C7.38343 10.988 7.38321 10.9788 7.38283 10.9695C7.38326 10.9799 7.38348 10.9903 7.38348 11.0007C7.38348 10.9995 7.38348 10.9983 7.38347 10.9971ZM6.31392 10.3102C6.08599 10.4216 5.87388 10.6453 5.88362 11.0171C5.89297 11.5404 6.35006 11.7793 6.66681 11.7793C6.98685 11.7793 7.45014 11.5354 7.45014 11.0007C7.45014 10.6283 7.22531 10.3969 6.9807 10.2908C6.88521 10.2467 6.77888 10.2222 6.66681 10.2222C6.53924 10.2222 6.4191 10.254 6.31392 10.3102Z",
    className: "icon-fill"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.0271 10.2865C8.77749 10.3925 8.55078 10.628 8.55078 10.9995C8.55078 11.5342 9.01407 11.7781 9.33411 11.7781C9.65415 11.7781 10.1174 11.5342 10.1174 10.9995C10.1174 10.627 9.89261 10.3957 9.648 10.2896C9.55251 10.2455 9.44618 10.2209 9.33411 10.2209C9.22473 10.2209 9.12081 10.2444 9.0271 10.2865Z",
    className: "icon-fill"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.38347 8.28327C7.38343 8.27412 7.38321 8.26491 7.38283 8.25563C7.38326 8.26604 7.38348 8.27645 7.38348 8.28686C7.38348 8.28567 7.38348 8.28447 7.38347 8.28327ZM6.31392 7.59634C6.08599 7.70778 5.87388 7.93141 5.88362 8.30323C5.89297 8.82653 6.35006 9.06543 6.66681 9.06543C6.98685 9.06543 7.45014 8.82155 7.45014 8.28686C7.45014 7.91438 7.22531 7.68303 6.9807 7.57694C6.88521 7.53288 6.77888 7.5083 6.66681 7.5083C6.53924 7.5083 6.4191 7.54015 6.31392 7.59634Z",
    className: "icon-fill"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.0271 7.57259C8.77749 7.67858 8.55078 7.91409 8.55078 8.28564C8.55078 8.82033 9.01407 9.06421 9.33411 9.06421C9.65415 9.06421 10.1174 8.82033 10.1174 8.28564C10.1174 7.91316 9.89261 7.68181 9.648 7.57572C9.55251 7.53166 9.44618 7.50708 9.33411 7.50708C9.22473 7.50708 9.12081 7.5305 9.0271 7.57259Z",
    className: "icon-fill"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalculator);
export default __webpack_public_path__ + "static/media/icon-calculator.b69fe31b947651e8626c6de8ec42eee8.svg";
export { ForwardRef as ReactComponent };